/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import axios from 'axios';
import { saveAs } from 'file-saver';
import { remove } from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';

import {
    activeDataReconMenuVar, showDataReconMenusVar, leftNavigationItemsVar,
    currentLeftMenuVar,
} from 'Apollo/config';
import { CREATE_RECON_USER_COMMENTS } from 'Apollo/Mutations/DataRecon/DataConfiguration';
import { GET_USER_INFO } from 'Apollo/Queries';
import {
    GET_FILTERED_FILE_DATA, GET_PROJECT_CONFIGURATION, GET_RECON_NODE_LIST, GET_RECON_RESULT_TABLE_DATA, GET_RECON_USER_COMMENTS,
} from 'Apollo/Queries/DataRecon/DataConfiguration';
import { ModuleEnum } from 'constants';
import { getAuthorizationHeaderValue, getAccessToken } from 'views/Auth/AuthHelper';
import crossReportImg from 'assets/images/cross-report-black.svg';
import ReconResult from '../components/ReconResult';

const baseLink = process.env.REACT_APP_BASE_LINK;

let currentTab = '1';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const noOfItemsToShow = 3;

/* List of Columns for Result Table */
const columns = [
    {
        Header: 'Exception Type',
        accessor: 'exceptionType',
        minWidth: 120,
        resizable: true,
        sortable: true,
    },
    {
        Header: 'Source Aggregated On',
        accessor: 'sourceAggregatedOn',
        minWidth: 200,
        resizable: true,
        sortable: true,
    },
    {
        Header: 'Source Transaction Amount',
        accessor: 'sourceTransactionAmount',
        minWidth: 200,
        resizable: true,
        sortable: true,
    },
    {
        Header: 'Target Aggregated On',
        accessor: 'targetAggregatedOn',
        minWidth: 200,
        resizable: true,
        sortable: true,
    },
    {
        Header: 'Target Transaction Amount',
        accessor: 'targetTransactionAmount',
        minWidth: 190,
        resizable: true,
        sortable: true,
    },
    {
        Header: 'Delta',
        accessor: 'delta',
        minWidth: 70,
        resizable: true,
        sortable: true,
    },
];
const getReconNode = (reconNodeList, element, subProjectId) => reconNodeList.getReconOperationNodesList
    .find(({ nodeId, projectId }) => nodeId === element.id && projectId === subProjectId);
const getElementsWhenReconStatusIsAvailable = (oldElemets, reconNodeList, subProjectId) => oldElemets.map(el => {
    const node = getReconNode(reconNodeList, el, subProjectId);
    if (node) {
        switch (node.batchStatus) {
            case 'Exception': {
                const newData = { ...el.data, status: 'Exception' };
                return {
                    ...el,
                    data: newData,
                };
            }
            case 'Success': {
                const newData = { ...el.data, status: 'Success' };
                return {
                    ...el,
                    data: newData,
                };
            }
            default:
                return { ...el, style: {} };
        }
    }
    return { ...el, style: {} };
});
const getChildFlow = (prevState, projectConfig) => {
    const oldState = [...prevState];
    const brdItems = [
        {
            link: '',
            value: projectConfig.projectName,
            name: projectConfig.projectName,
        },
    ];
    const index = oldState.findIndex(x => x.name === projectConfig.projectName);
    oldState.splice(index + 1);
    brdItems.forEach(item => {
        remove(oldState, oldItem => oldItem.name === item.name);
    });
    return oldState.length > 0 ? oldState.concat(brdItems) : oldState;
};
const checkReconResultTableDataAvailable = reconResultTableData => reconResultTableData
    && reconResultTableData.getReconResultTableData
    && Object.keys(reconResultTableData.getReconResultTableData).length > 0;
const getSelectedNode = reconResultTableData => {
    let updatedNode;
    if (reconResultTableData.getReconResultTableData.successBatchTests.length > 0) {
        updatedNode = reconResultTableData.getReconResultTableData.successBatchTests[0].nodeId;
    } else {
        updatedNode = reconResultTableData.getReconResultTableData.exceptionBatchTests[0].nodeId;
    }
    return updatedNode;
};
const getBatchId = reconResultTableData => {
    let batchId;
    if (reconResultTableData.getReconResultTableData.successBatchTests.length > 0) {
        batchId = reconResultTableData.getReconResultTableData.successBatchTests[0].batchId;
    } else {
        batchId = reconResultTableData.getReconResultTableData.exceptionBatchTests[0].batchId;
    }
    return batchId;
};
const getTableData = reconResultTableData => {
    const successResult = reconResultTableData.getReconResultTableData.successBatchTests;
    const exceptionResult = reconResultTableData.getReconResultTableData.exceptionBatchTests;
    return { successResult, exceptionResult };
};

const getColsData = fileDataResult => {
    const cols = [];
    if (fileDataResult.getFilterPreviewData.fileData && Object.keys(fileDataResult.getFilterPreviewData.fileData[0]).length > 0) {
        const configData = Object.keys(fileDataResult.getFilterPreviewData.fileData[0]);
        configData.forEach(c => {
            cols.push({
                accessor: c,
                Header: c,
                resizable: true,
                minWidth: 85,
            });
        });
    }
    return cols;
};

const ReconResultContainer = () => {
    const history = useHistory();
    const location = useLocation();
    const [tenantId, setTenantId] = useState(location.state.tenantId);
    const [project, setProject] = useState(location.state.project);
    const [itemsToShow, setItemsToShow] = useState(noOfItemsToShow);
    const [showAllCommentsBtn, setShowAllCommentsBtn] = useState(true);
    const [comments, setComments] = useState('');
    const [selectedNode, setSelectedNode] = useState(null);
    const [elements, setElements] = useState([]);
    const [userNode, setUserNode] = useState(null);
    const [configLoading, setConfigLoading] = useState(null);
    const [projectConfig, setProjectConfig] = useState(null);
    const [childFlow, setChildFlow] = useState([]);
    const [subProjectId, setSubProjectId] = useState(null);
    const [successData, setSuccessData] = useState([]);
    const [exceptionData, setexceptionData] = useState([]);
    const [batchId, setBatchId] = useState(null);
    const [nodeConfig, setNodeConfig] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [fileData, setFileData] = useState([]);
    const [fileCols, setFileCols] = useState([]);
    const [resultDataLoading, setResultDataLoading] = useState(null);
    const [activeTab, setActiveTab] = useState('1');
    const [disableFileTab, setDisableFileTab] = useState(true);
    const [selectedElement, setSelectedElement] = useState(null);
    const [isfilteredData, setIsFilteredData] = useState(null);
    const [toastMessage, setToastMessage] = useState('');
    const [isFileDownloading, setIsFileDownloading] = useState(false);
    /* apollo query to fetch user info */
    const { data = {} } = useQuery(GET_USER_INFO);
    const {
        getUser: {
            initials = '',
        } = {},
    } = data;
    /* apollo query to fetch project configuration */
    const [getProjectConfigDetails, { data: configFlowData, loading: configFlowLoading }] = useLazyQuery(GET_PROJECT_CONFIGURATION, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 10,
                pageNumber: 1,
                projectId: parseInt(subProjectId, 10),
            },
        },
    });
    /* apollo query to fetch filtered data for selected file */
    const [getFilteredFileData, { data: fileDataResult, loading: fileDataLoading }] = useLazyQuery(GET_FILTERED_FILE_DATA, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                fileName,
                projectId: parseInt(project?.projectId, 10),
                batchTestProjectId: parseInt(subProjectId, 10),
                nodeId: selectedElement ? selectedElement.id : null,
            },
        },
    });
    /* apollo query to fetch project reconciliation result */
    const [getReconResultTableData, { data: reconResultTableData, loading: reconResultLoading }] = useLazyQuery(GET_RECON_RESULT_TABLE_DATA, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                projectId: parseInt(project?.projectId, 10),
                batchTestProjectId: parseInt(subProjectId, 10),
                pageSize: 10000,
                pageNumber: 1,
                nodeId: selectedNode,
            },
        },
    });
    /* apollo query to fetch recon user comments */
    const getUserComments = useQuery(GET_RECON_USER_COMMENTS, {
        variables: {
            input: {
                projectId: parseInt(project && project.projectId, 10),
            },
        },
    });
    /* apollo mutation to create recon user comments  */
    const [createComment, { loading: createIsLoading }] = useMutation(CREATE_RECON_USER_COMMENTS, {
        variables: {
            input: {
                batchId,
                commentText: comments,
                projectId: parseInt(project && project.projectId, 10),
            },
        },
    });
    /* apollo query to fetch reconciliation node list */
    const [getReconNodeList, { data: reconNodeList }] = useLazyQuery(GET_RECON_NODE_LIST, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                projectId: parseInt(project?.projectId, 10),
                batchTestProjectId: parseInt(subProjectId, 10),
            },
        },
    });
    /* function called when an element is clicked */
    const onElementClick = (event, element) => {
        if (element.type === 'default') {
            setSelectedNode(element.id);
            setFileName(null);
            setFileData([]);
            setDisableFileTab(true);
        } else if (element.type === 'input') {
            setSelectedNode(null);
            setSelectedElement(element);
            setDisableFileTab(false);
            setSuccessData([]);
            setexceptionData([]);
            setFileData([]);
            setFileName(element.data.fileName);
        } else {
            setSelectedNode(null);
            setUserNode(element);
            setSuccessData([]);
            setexceptionData([]);
            setFileName(null);
            setFileData([]);
            setDisableFileTab(true);
        }
    };
    /* function called to change bread crumbs when sub projects is selected */
    const changeProjectBreadCrumbs = () => {
        setSubProjectId(projectConfig.projectId);
        setChildFlow(prevState => getChildFlow(prevState, projectConfig));
    };
    /* function to navigate to projects page */
    const navigateToProjects = () => history.push(
        {
            pathname: '/projects',
            state: {
                tenantId,
            },
        },
    );
    /* function to navigate to Data Recon home page */
    const navigateToReconHome = () => history.push(
        {
            pathname: '/data-recon-home',
            state: {
                tenantId,
            },
        },
    );
    /* callback function called when Download Result button is clicked */
    const downloadFile = async () => {
        const token = getAuthorizationHeaderValue();
        try {
            setIsFileDownloading(true);
            const url = `${baseLink}api/reconciliation/downloadReconResultFiles/${project && project.projectId}/${selectedNode}`;
            const response = await axios.get(url, {
                headers: {
                    authorization: token ? `Bearer ${token}` : '',
                    token: getAccessToken(),
                    'x-isRestAPI': true,
                },
            });
            const updatedData = new Blob([response.data], { type: 'text/csv' });
            saveAs(updatedData, `${selectedNode}.csv`);
            setIsFileDownloading(false);
            setToastMessage('Download is completed');
        } catch (err) {
            //
        }
    };
    /* Breadcrumb items */
    const breadCrumbItems = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={navigateToReconHome} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={navigateToProjects} role="presentation"> Projects </span>,
        },
        {
            link: '',
            value: (
                <span
                    className="a-breadcrumb-item-text"
                    onClick={() => {
                        history.push({
                            pathname: '/data-lineage-upload',
                            state: {
                                tenantId, project,
                            },
                        });
                    }}
                    role="presentation"
                >
                    {project?.projectName}
                </span>
            ),
        },
        {
            link: '',
            value: (
                <span
                    className="a-breadcrumb-item-text"
                    onClick={() => {
                        history.push({
                            pathname: '/dataconfiguration',
                            state: {
                                projectId: project?.projectId,
                                tenantId,
                                project,
                            },
                        });
                    }}
                    role="presentation"
                >
                    Data Configuration
                </span>
            ),
        },
        {
            link: '',
            value: `${project ? project.projectName : ''} - Reconciliation Result`,
        },
    ];
    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);
    /* side effect when selectedNode and projectConfig is changed */
    useEffect(() => {
        if (selectedNode && projectConfig && Object.keys(projectConfig.flowConfig).length > 0) {
            setNodeConfig(projectConfig.flowConfig[selectedNode]);
        }
    }, [selectedNode, projectConfig]);
    /* side effect when location is changed */
    useEffect(() => {
        setTenantId(location.state.tenantId);
        setProject(location.state.project);
        setSubProjectId(location.state.project.projectId);
        showDataReconMenusVar(true);
        activeDataReconMenuVar('projects');
    }, [location]);
    /* side effect when subProjectId is changed */
    useEffect(() => {
        getProjectConfigDetails();
        getReconNodeList();
    }, [subProjectId]);
    /* side effect when userNode is changed */
    useEffect(() => {
        if (userNode && userNode.type === 'special') {
            setSubProjectId(userNode.data.projectId);
            setChildFlow(prevState => {
                const oldState = [...prevState];
                const brdItems = [
                    {
                        link: '',
                        value: (
                            <span
                                className="a-breadcrumb-item-text"
                                onClick={changeProjectBreadCrumbs}
                                role="presentation"
                            >
                                {projectConfig.projectName}
                            </span>
                        ),
                        name: projectConfig.projectName,
                    },
                    {
                        link: '',
                        value: userNode.data.label,
                        name: userNode.data.label,
                    },
                ];
                brdItems.forEach(item => {
                    remove(oldState, oldItem => oldItem.name === item.name);
                });
                return [...oldState.concat(brdItems)];
            });
        }
    }, [userNode]);
    /* side effect when fileDataResult is changed */
    useEffect(() => {
        if (fileDataResult && fileDataResult.getFilterPreviewData) {
            const cols = getColsData(fileDataResult);
            setFileCols(cols);
            setFileData(fileDataResult.getFilterPreviewData.fileData);
            setIsFilteredData(fileDataResult.getFilterPreviewData.isfilterData);
        }
    }, [fileDataResult]);
    /* side effect when fileData is changed toggle active tab */
    useEffect(() => {
        if (fileData.length > 0) {
            setActiveTab('3');
            currentTab = '3';
            setDisableFileTab(false);
        } else {
            setActiveTab('1');
            currentTab = '1';
            setDisableFileTab(true);
        }
    }, [fileData]);
    /* side effect when configFlowLoading is changed */
    useEffect(() => {
        setConfigLoading(configFlowLoading);
    }, [configFlowLoading]);
    /* side effect when configFlowData and configFlowLoading is changed */
    useEffect(() => {
        if (!configFlowLoading && configFlowData && configFlowData.getChildProjectsConfiguration && configFlowData.getChildProjectsConfiguration.projectConfig) {
            const newNode = Object.keys(configFlowData.getChildProjectsConfiguration.projectConfig.flowConfig)[0];
            setSelectedNode(newNode);
            setProjectConfig(configFlowData.getChildProjectsConfiguration.projectConfig);
        }
    }, [configFlowData, configFlowLoading]);
    /* side effect when reconNodeList and configFlowData is changed, set elements based on recon function status */
    useEffect(() => {
        const isReconNodeListDataAvailable = reconNodeList?.getReconOperationNodesList;
        const isConfigFlowDataAvailable = configFlowData && Object.keys(configFlowData.getChildProjectsConfiguration.projectConfig).length > 0
        && Object.keys(configFlowData.getChildProjectsConfiguration.projectConfig.diagramFlow).length > 0;
        if (isConfigFlowDataAvailable) {
            if (isReconNodeListDataAvailable) {
                let oldElemets = configFlowData.getChildProjectsConfiguration.projectConfig.diagramFlow.elements;
                oldElemets = getElementsWhenReconStatusIsAvailable(oldElemets, reconNodeList, subProjectId);
                setElements(oldElemets);
            } else {
                let oldElements = configFlowData.getChildProjectsConfiguration.projectConfig.diagramFlow.elements;
                oldElements = oldElements.map(el => {
                    if (el.type === 'default') {
                        return { ...el, style: { color: '#7D7D7D', fontWeight: 'bold' } };
                    }
                    return { ...el, style: {} };
                });
                setElements(oldElements);
            }
        }
    }, [reconNodeList, configFlowData]);
    /* side effect when recon result data is changed */
    useEffect(() => {
        const isReconResultTableDataAvailable = checkReconResultTableDataAvailable(reconResultTableData);
        if (!selectedNode && isReconResultTableDataAvailable) {
            /* select default node when result data is available */
            setSelectedNode(getSelectedNode(reconResultTableData));
        }
        if (isReconResultTableDataAvailable) {
            setBatchId(getBatchId(reconResultTableData));
            const { successResult, exceptionResult } = getTableData(reconResultTableData);
            setSuccessData(successResult);
            setexceptionData(exceptionResult);
        }
    }, [reconResultTableData]);
    /* side effect when reconResultLoading is changed */
    useEffect(() => {
        setResultDataLoading(reconResultLoading);
    }, [reconResultLoading]);
    /* side effect when selectedNode is changed */
    useEffect(() => {
        if (selectedNode) {
            getReconResultTableData();
        }
    }, [selectedNode]);
    /* side effect when selectedElement is changed */
    useEffect(() => {
        if (fileName && selectedElement) {
            getFilteredFileData();
        }
    }, [fileName, selectedElement]);
    return (
        <div>
            <ReconResult
                columns={columns}
                initials={initials}
                commentData={getUserComments}
                itemsToShow={itemsToShow}
                setItemsToShow={setItemsToShow}
                showAllCommentsBtn={showAllCommentsBtn}
                setShowAllCommentsBtn={setShowAllCommentsBtn}
                breadCrumbItems={breadCrumbItems}
                project={project}
                comments={comments}
                setComments={setComments}
                createComment={createComment}
                downloadFile={downloadFile}
                elements={elements}
                onElementClick={onElementClick}
                childFlow={childFlow}
                configLoading={configLoading}
                successData={successData}
                exceptionData={exceptionData}
                nodeConfig={nodeConfig}
                fileData={fileData}
                fileCols={fileCols}
                fileName={fileName}
                fileDataLoading={fileDataLoading}
                resultDataLoading={resultDataLoading}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                disableFileTab={disableFileTab}
                isfilteredData={isfilteredData}
                createIsLoading={createIsLoading}
                currentTab={currentTab}
                toastMessage={toastMessage}
                setToastMessage={setToastMessage}
                isFileDownloading={isFileDownloading}
            />
        </div>
    );
};

export default ReconResultContainer;
